// extracted by mini-css-extract-plugin
export default {"container":"styles_container__M9OOR","card_action":"styles_card_action__9BAKt","title":"styles_title__AbuAR","content":"styles_content__3wyKt"};